import { Permission } from '@statsbomb/kitbag-components/types/components/ShareModal/types';
import { useAtomValue } from 'jotai';
import { upsertUserConfigPermissionsAtom } from '@/atoms/mutations/userConfigs/userConfigs';
import { rawUserConfigPermissionsAtom, userConfigsAtom } from '@/atoms/queries/userConfigs';
import { isNonOwnerPermission } from '@/utils/predicates';

export const useUpsertUserConfigPermissions = () => {
  const userConfigs = useAtomValue(userConfigsAtom);
  const userConfigPermissions = useAtomValue(rawUserConfigPermissionsAtom);
  const { mutateAsync: upsertPermissions, isPending } = useAtomValue(upsertUserConfigPermissionsAtom);

  const upsertUserConfigPermissions = async (permissions: { id: string | number; permission: Permission }[]) => {
    const filteredPermissions = permissions
      .filter(isNonOwnerPermission)
      .map(({ id, permission }) => ({ hudl_user_id: String(id), permission }));

    const { isSuccess } = await upsertPermissions(filteredPermissions);

    if (isSuccess) {
      // user configs include permission data, so we need to refetch both to ensure the UI is up to date after a successful mutation.
      await Promise.all([userConfigPermissions.refetch(), userConfigs.refetch()]);
    }

    return { isSuccess };
  };

  return { upsertUserConfigPermissions, isPending };
};
